
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'App',
    data() {
        return {
            text: '',
            translation: ''
        }
    },
    watch: {
        'text': function() {
            this.translate()
        }
    },
    methods: {
        translate() {
            this.translation = ''
            const array: string[] = this.text.split('')
            const letters = 'abcdefghijklmnoqrstuvwz'
            const galactic = 'ᔑʖᔮ↸ᒷ⎓┤⍑╎⋮ꖌꖎᒲリ𝙹ᑑ∷ᓭℸ⚍⍊∴∩'
            for(let char of array) {
                char = char.toLowerCase()
                if(letters.split('').includes(char)) {
                    const index = letters.split('').findIndex((x) => x == char)
                    this.translation += galactic[index]
                }
                else if(char == 'p') this.translation += '¡!'
                else if(char == 'x') this.translation += ' ̇/'
                else if(char == 'y') this.translation += '||'
                else if(char == ' ') this.translation += String.fromCharCode(160)
                else continue
            }
        }
    }
})
